import * as React from 'react';
import { IOSSwitch } from './Switch';

export const ContentItem = ({ item }: { item: any }) => {
  return (
    <>
      <div className="flex items-center justify-between text-lg lg:py-4">
        <div className="font-medium lg:font-normal">{item.title}</div>
        <div>
          {item.needConfirm === 0 ? (
            false
          ) : item.needConfirm === 1 ? (
            <div className="text-sm capitalize text-[#5E00FF]">
              always active
            </div>
          ) : (
            <div>
              <IOSSwitch
                sx={{ m: 1 }}
                defaultChecked
                onChange={(e) => {
                  // console.log(e.target.checked);
                }}
              />
            </div>
          )}
        </div>
      </div>
      <div className="h-full overflow-auto text-sm capitalize">
        {item.content}
      </div>
    </>
  );
};
